import {Observable} from 'rxjs';
import {createAction} from 'redux-actions';

import {combineEpics} from 'web-app/util/redux-observable';
import * as actionTypes from 'web-app/react/constants/action-types';
import PermissionsApi from 'web-app/api/permissions-api';
import {replayOnTriggerObservable} from 'web-app/util/epics-helpers';

const fetchChildPermissions = action$ =>
    action$.ofType(actionTypes.CHILD_PERMISSION_FETCH).mergeMap(({payload}) =>
        Observable.fromPromise(PermissionsApi.listForChild(payload.childId))
            .map(user => createAction(actionTypes.CHILD_PERMISSION_FETCH_SUCCESS)(user))
            .catch(e => Observable.of(createAction(actionTypes.CHILD_PERMISSION_FETCH_ERROR)(e))),
    );

const updateChildPermission = action$ =>
    action$.ofType(actionTypes.UPDATE_PERMISSION).mergeMap(({payload}) =>
        Observable.fromPromise(PermissionsApi.updatePermission(payload.permissionReplyId, payload.answer))
            .map(response => {
                if (response) {
                    return createAction(actionTypes.UPDATE_PERMISSION_SUCCESS)(payload);
                } else {
                    return createAction(actionTypes.UPDATE_PERMISSION_ERROR)(payload);
                }
            })
            .catch(() => Observable.of(createAction(actionTypes.UPDATE_PERMISSION_ERROR)(payload))),
    );

const listenForUpdates = action$ => {
    const replayObservable = action$.ofType(actionTypes.CHILD_PERMISSION_FETCH);

    const resetObservable = Observable.empty();

    const triggerReplayObservable = Observable.merge(action$.ofType(actionTypes.UPDATE_PERMISSION_SUCCESS));

    return replayOnTriggerObservable(replayObservable, resetObservable, triggerReplayObservable).catch(
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        () => {},
    );
};

export default combineEpics(listenForUpdates, fetchChildPermissions, updateChildPermission);
